import { inflection } from '@piccolohealth/util';
import React from 'react';
import { ChakraV3 } from '..';
import { MultiSelectComponents } from './MultiSelect';

interface Props {
  items: string;
  total: number;
  hasMore: boolean;
  isLoading: boolean;
  fetchNextPage: () => void;
}

export const PaginationSelectFooter = (props: Props) => {
  return (
    <MultiSelectComponents.Footer>
      <ChakraV3.Text fontSize='xs' whiteSpace='nowrap'>
        {props.total} {inflection.inflect(props.items, props.total)}
      </ChakraV3.Text>
      <ChakraV3.Spacer />
      <ChakraV3.Button
        variant='plain'
        onClick={props.fetchNextPage}
        fontSize='xs'
        disabled={!props.hasMore}
        loading={props.isLoading}
        justifyContent='end'
      >
        Load more
      </ChakraV3.Button>
    </MultiSelectComponents.Footer>
  );
};
